// French for the page titles (PAGES[].title) — the sidebar and the topbar wrap them with t().
import { registerFr } from '../i18n/index.js';

registerFr({
  'Today': 'Aujourd’hui',
  'Review': 'Revue',
  'Inbox': 'Boîte de réception',
  'People': 'Personnes',
  'Person': 'Personne',
  'Organisations': 'Organisations',
  'Organisation': 'Organisation',
  'Pipeline': 'Pipeline',
  'Search': 'Recherche',
  'Market': 'Marché',
  'Network': 'Réseau',
  'Signals': 'Signaux',
  'Campaigns': 'Campagnes',
  'Agents': 'Agents',
  'Run': 'Passe',
  'Sources': 'Sources',
  'Admin': 'Administration',
}, 'registry');
